import React from "react";
import { Trans } from "react-i18next";

export const SidebarData = [
  {
    id: 1,
    title: "Introduction",
    path: "/e-commerce/technical-document-pages/technical-document",
  },
  {
    id: 2,
    title: "Certificate creation",
    path: "/e-commerce/technical-document-pages/certificate-creation",
  },

  {
    id: 3,
    title: "Create Order Purchase",
    path: "#",
    subNav: [
      {
        Subtitle: "Request Format",
        path: "/e-commerce/technical-document-pages/request-format",
      },
      {
        Subtitle: "XML",
        path: "/e-commerce/technical-document-pages/xml",
      },
      {
        Subtitle: "JSON",
        path: "/e-commerce/technical-document-pages/json",
      },
    ],
  },

  {
    id: 4,
    title: "Request for Quasi Cash Purchase",
    path: "/e-commerce/technical-document-pages/request-quasi-cash",
  },

  {
    id: 5,
    title: "Preauthorization",
    path: "#",
    subNav: [
      {
        Subtitle: "XML",
        path: "/e-commerce/technical-document-pages/preauthorization-xml",
      },
      {
        Subtitle: "JSON",
        path: "/e-commerce/technical-document-pages/preauthorization-json",
      },
    ],
  },
  {
    id: 6,
    title: "Completion",
    path: "#",
    subNav: [
      {
        Subtitle: "XML",
        path: "/e-commerce/technical-document-pages/completion-xml",
      },
      {
        Subtitle: "JSON",
        path: "/e-commerce/technical-document-pages/completion-json",
      },
    ],
  },
  {
    id: 7,
    title: "Reversal",
    path: "#",
    subNav: [
      {
        Subtitle: "XML",
        path: "/e-commerce/technical-document-pages/payment-reversal-xml",
      },
      {
        Subtitle: "JSON",
        path: "/e-commerce/technical-document-pages/payment-reversal-json",
      },
    ],
  },
  {
    id: 8,
    title: "Partial Reversal",
    path: "/e-commerce/technical-document-pages/partial-reversal-json",
  },

  {
    id: 9,
    title: "Refund",
    path: "#",
    subNav: [
      {
        Subtitle: "XML",
        path: "/e-commerce/technical-document-pages/refund-xml",
      },
      {
        Subtitle: "JSON",
        path: "/e-commerce/technical-document-pages/refund-json",
      },
    ],
  },
  {
    id: 10,
    title: "Get Order Details (getOrder) Operation",
    path: "/e-commerce/technical-document-pages/get-order-details-json",
  },
  {
    id: 11,
    title: "Recurrent Payment MIT",
    path: "#",
    subNav: [
      {
        Subtitle: "JSON",
        path: "/e-commerce/technical-document-pages/recurrent-payment-mit-json",
      },
    ],
  },

  {
    id: 12,
    title:
      "EMV 3-D Secure Authentication without Redirecting to TXPG payment Page",
    path: "#",
    subNav: [
      {
        Subtitle: "XML",
        path: "/e-commerce/technical-document-pages/authentication-xml",
      },
      {
        Subtitle: "JSON",
        path: "/e-commerce/technical-document-pages/authentication-json",
      },
    ],
  },
  {
    id: 13,
    title: "Recurrent Payment CIT",
    path: "#",
    subNav: [
      {
        Subtitle: "JSON",
        path: "/e-commerce/technical-document-pages/recurrent-payment-cit-json",
      },
      
    ],
  },
  {
    id: 14,
    title: "P2P Credit",
    path: "#",
    subNav: [
      {
        Subtitle: "JSON",
        path: "/e-commerce/technical-document-pages/p2pcedit-json",
      },
      
    ],
  },
  {
    id: 15,
    title: "Card To Card Transfer via TXPG API",
    path: "#",
    subNav: [
      {
        Subtitle: "JSON",
        path: "/e-commerce/technical-document-pages/card-to-card-transfer-json",
      },
    ],
  },
  {
    id: 16,
    title: "C2C Transfer (Merchant Do not need PCI DSS )",
    path: "#",
    subNav: [
      {
        Subtitle: "JSON",
        path: "/e-commerce/technical-document-pages/c2c-transfer-json",
      },
    ],
  },
  {
    id: 17,
    title: "Errors",
    path: "/e-commerce/technical-document-pages/error",
  },
  {
    id: 18,
    title: "Apple Pay ™",
    path: "/e-commerce/technical-document-pages/apple-pay",
  },
  {
    id: 19,
    title: "Google Pay ™ ",
    path: "/e-commerce/technical-document-pages/google-pay",
  },
];
